import type { ReferencedEntry } from 'contentful';
import React from 'react';

import { ContentType, Product } from 'api/contentful/contentTypes.cloverdotcom';
import { getContentType } from 'utils/CloverdotcomEntryUtil';

import { getField } from 'utils/EntryUtil';
import { ExternalLink } from './ExternalLink';
import type { IContentLink } from './IContentLink';
import { InternalLink } from './InternalLink';
import { ModalLink } from './ModalLink';
import { PageLink } from './PageLink';

export interface IContentLinkProps extends IContentLink {
  alwaysRenderChildren?: boolean;
  dataTestIdPrefix?: string;
  isTextVariant?: boolean;
}
export const ContentLink: React.FC<IContentLinkProps> = ({
  entry,
  alwaysRenderChildren,
  dataTestIdPrefix,
  innerRef,
  ...props
}) => {
  switch (getContentType(entry)) {
    case ContentType.PRODUCT:
      return (
        <ContentLink
          alwaysRenderChildren={alwaysRenderChildren}
          innerRef={innerRef}
          entry={getField(entry as ReferencedEntry<Product>, 'link')}
          {...props}
        />
      );

    case ContentType.BASIC_PAGE:
      return <PageLink innerRef={innerRef} entry={entry} {...props} />;

    case ContentType.INTERNAL_LINK:
      return (
        <InternalLink innerRef={innerRef} entry={entry} dataTestIdPrefix={dataTestIdPrefix} {...props} />
      );

    case ContentType.EXTERNAL_LINK:
      return (
        <ExternalLink innerRef={innerRef} entry={entry} dataTestIdPrefix={dataTestIdPrefix} {...props} />
      );

    case ContentType.MODAL_LINK:
      return <ModalLink innerRef={innerRef} entry={entry} {...props} />;

    default:
      if (alwaysRenderChildren) {
        const { hideTitle, children, ...otherProps } = props;
        return (
          <a ref={innerRef} {...otherProps}>
            {children}
          </a>
        );
      }

      return null;
  }
};
